import zonesSlice from "./redux/slice";

export const ZonesFeatureReducers = {
  ZonesReducer: zonesSlice.reducer,
};